
export async function getPlaces(text: string) {
    const { Place } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
    const request = {
        textQuery: text,
        fields: ['id', 'displayName', 'location', 'addressComponents', 'photos'],
        includedType: 'tourist_attraction',
        language: 'en-US',
        useStrictTypeFiltering: false,
    };

    //@ts-ignore
    const { places } = await Place.searchByText(request);
    return places;
}

export async function getPlacesNearby(
    center: google.maps.LatLngLiteral,
    radiusMeters = 20000
) {
    const { Place } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
    const request: google.maps.places.SearchNearbyRequest = {
        fields: ['id', 'displayName', 'location', 'addressComponents', 'photos'],
        includedTypes: ['tourist_attraction'],
        language: 'en-US',
        locationRestriction: {
            center,
            radius: Math.min(Math.max(radiusMeters, 1000), 50000),
        },
        maxResultCount: 20,
        rankPreference: google.maps.places.SearchNearbyRankPreference.POPULARITY,
    };
    // @ts-ignore searchNearby available on experimental lib
    const { places } = await Place.searchNearby(request);
    return places;
}
